# small wrapper around queryObject.js to set defaults, extend to allow string manipulation, and alias PT.Utils
class QueryObject
  constructor: ->
    queryObject.useHistory = true

  # Get full querystring, or specific params
  # @param {String|Array} Array of keys or string of single key
  get: (key) ->
    params = queryObject.get(key)

    # fixes bug in queryObject.js where checking for a specific param
    # that doesn't exist returns an empty object instead of undefined
    if key && _.isEmpty(params)
      undefined
    else
      params

  # Clear and set querystring
  # @param {Object} Object of params to set
  # @param {Boolean} Option to use replaceState instead of pushState
  set: (queryObj, useReplaceState = false) ->
    queryObject.set(queryObj, useReplaceState)

  # Add one or more params to querystring
  # @param {Object} Object of params to be added
  # @param {Boolean} Option to use replaceState instead of pushState
  add: (queryObj, useReplaceState = false) ->
    queryObject.add(queryObj, useReplaceState)

  # Remove one or more params from querystring
  # @param {String|Array} Array of keys or string of single key
  # @param {Boolean} Option to use replaceState instead of pushState
  remove: (key, useReplaceState = false) ->
    queryObject.remove(key, useReplaceState)

  # Get params from querystring string
  # @param {String|Array} Array of keys or string of single key
  # @param {String} href
  getFromString: (key, href) ->
    if !key || href.indexOf('?') == -1
      return

    query = $.deparam(href.split('?')[1])

    if Array.isArray(key)
      temp = {}

      key.forEach (key) ->
        if query.hasOwnProperty(key)
          temp[key] = query[key]

      return temp

    query[key]

  # Clear and set querystring on string
  # @param {Object} Object of params to set
  # @param {String} href
  setToString: (queryObj, href) ->
    if !queryObj || typeof queryObj != 'object'
      return

    query = ''

    for prop of queryObj
      query += encodeURIComponent(prop)
      if queryObj[prop]
        query += '=' + encodeURIComponent(queryObj[prop])
      query += '&'

    query = query.slice(0, -1)
    query = '?' + query if query
    href = if href.indexOf('?') != -1 then href.substr(0, href.indexOf('?')) else href

    href + query

  # Add one or more params to string
  # @param {Object} Object of params to be added
  # @param {String} href
  addToString: (queryObj, href) ->
    if !queryObj || typeof queryObj != 'object'
      return

    if href.indexOf('?') != -1
      query = $.deparam(href.split('?')[1])
    else
      query = {}

    for prop of queryObj
      query[prop] = queryObj[prop]

    @setToString(query, href)

  # Remove one or more params from string
  # @param {String|Array} Array of keys or string of single key
  # @param {String} href
  removeFromString: (key, href) ->
    if !key || href.indexOf('?') == -1
      return

    query = $.deparam(href.split('?')[1])

    if Array.isArray(key)
      key.forEach (key) ->
        delete query[key]

    else if typeof key == 'string'
      delete query[key]

    @setToString(query, href)

PT.Utils.QueryObject = new QueryObject
